const MapLayerIcon = {
  PLAIN_VESSEL: {
    HIGHLIGHTED: 'plain-vessel-highlighted',
    NORMAL: 'plain-vessel',
    ALERT: 'alert',
    BORDER: 'border',
    NEARBY: 'nearby',
  },
  RI_VESSEL: {
    HIGHLIGHTED: 'ri-vessel-highlighted',
    NORMAL: 'ri-vessel',
  },
  INCIDENT: {
    DEFAULT: 'incident-default-marker',
    SELECTED: 'incident-default-marker-alert',
  },
  PORT: {
    DEFAULT: 'port-icon',
    DEFAULT_RI: 'port-icon-ri',
    SELECTED: 'port-icon-selected',
    SELECTED_RI: 'port-icon-selected-ri',
    INLAND_RI: 'port-inland-ri',
    CRUISE_RI: 'port-cruise-ri',
    SELECTED_CRUISE_RI: 'port-cruise-selected-ri',
  },
  HISTORIC_POSITION: 'historic-position',
  HISTORIC_MERGED_POSITION: 'historic-merged-position',
  RADIO_POSITION: 'radio-position',
  VESSEL_SEARCH_AREA: {
    NORMAL: 'vessel-search-area-normal',
    AMBER: 'vessel-search-area-amber',
    ALERT: 'vessel-search-area-alert',
  },
};

export default MapLayerIcon;
